import { createAsyncThunk } from "@reduxjs/toolkit";
import { homeBannerService } from "service/homeBannerService";
import { NOTIFY } from "constants/notifyType";
import Notify from "helpers/Notify";

export const getHomeBanner = createAsyncThunk(
  "homeBanner/getHomeBanner",
  async () => {
    try {
      const response = await homeBannerService.getHomeBanner();
      return response.data;
    } catch (error) {
      throw error;
    }
  }
);

export const updateHomeBanner = createAsyncThunk(
  "homeBanner/updateHomeBanner",
  async ({ id, bannerData }, { rejectWithValue }) => {
    try {
      const response = await homeBannerService.updateHomeBanner(id, bannerData);
      Notify(NOTIFY.type.success, NOTIFY.message.update);
      return response.data;
    } catch (error) {
      Notify(NOTIFY.type.error, NOTIFY.message.wrong);
      return rejectWithValue(error);
    }
  }
);
